import { useMemo } from "react";

import moment from "moment";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import useUpdateQueryParams from "./useUpdateQueryParams";

const useUpdateTimeframeUrl = (timeframe: TimeFrameType) => {
  const params = useMemo(() => {
    const { from, to, id } = timeframe;
    const unixTo = to ? moment(to).unix() : undefined;
    const unixFrom = from ? moment(from).unix() : undefined;
    return { to: unixTo?.toString(), from: unixFrom?.toString(), range: id };
  }, [timeframe]);
  useUpdateQueryParams(params);
};

export default useUpdateTimeframeUrl;
